import { apiClient as api } from "./httpClient";

/**
 * Plano de contas do livro-caixa (item 143): tipo › categoria › subcategoria.
 * Tipo: parentTypeId e parentCategoryId nulos. Categoria: só parentTypeId. Subcategoria: os dois.
 * A entidade vem da sessão; o nível não muda depois de criado (o histórico do livro aponta para a linha).
 */
export interface AccountCategory {
  id: string;
  type: string;
  description: string | null;
  parentTypeId: string | null;
  parentCategoryId: string | null;
  dre: boolean | null;
  costCenterCode: string | null;
  active: boolean;
  /** Lançamentos que usam a linha; quem tem uso só inativa, nunca sai. */
  usageCount: number;
}

export interface AccountCategoryPayload {
  type: string;
  description: string | null;
  parentTypeId: string | null;
  parentCategoryId: string | null;
  dre: boolean | null;
  costCenterCode: string | null;
}

export const accountCategoriesService = {
  list: async (): Promise<AccountCategory[]> => {
    const response = await api.get("/account-payable-types");
    return response.data;
  },

  create: async (payload: AccountCategoryPayload): Promise<string> => {
    const response = await api.post("/account-payable-types", payload);
    return response.data;
  },

  update: async (id: string, payload: { type: string; description: string | null; dre: boolean | null; costCenterCode: string | null; active?: boolean }): Promise<void> => {
    await api.put(`/account-payable-types/${id}`, payload);
  },

  /** Inativa (exclusão lógica); a API recusa linha com lançamentos ou com subcategorias ativas. */
  remove: async (id: string): Promise<void> => {
    await api.delete(`/account-payable-types/${id}`);
  },
};
